import { pageNumberState } from "@/atoms/order/page-number-state";
import { quotePageState } from "@/atoms/quote/quote-page-state";
import { Pagination, Table } from "flowbite-react";
import React from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

interface Props {
  headersLength: number;
}

export const PartnerQuoteFooter: React.FC<Props> = ({ headersLength }) => {
  const [page, setPage] = useRecoilState(quotePageState);

  const handlePageChange = (currentPage: number) => {
    setPage({ ...page, currentPage });
  };
  const setPageNumber = useSetRecoilState(pageNumberState);

  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex justify-end">
          <Pagination
            currentPage={page.currentPage}
            totalPages={page.totalPage}
            onPageChange={(currentPage: number) => {
              setPageNumber(currentPage);
            }}
            nextLabel=""
            previousLabel=""
            showIcons
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
